import {REQUEST_CURRENCY_LIST} from "@actions/actionTypes";

export function getCurrencyList() {
    return dispatch => {
        dispatch({
            type: REQUEST_CURRENCY_LIST
        });
    }
}
